import React from 'react'

import { Context } from 'modules/core/components/DataTable/contexts/SelectedRowsContext'

const useSelectedRows = () => {
  const value = React.useContext(Context)

  if (!value) {
    throw new Error('useSelectedRows must be used within a SelectedRowsProvider')
  }

  return value
}

export default useSelectedRows
